/** @format */

import React from "react";
import { Modal } from "react-bootstrap";
//import { useAppSelector } from '../../app/hooks';
import CardIcon from "../activityCards/CardIcon";
//import { selectAction, selectItemId } from './contentEditorSlice';
import { CloseButtonVariant } from "react-bootstrap/esm/CloseButton";

import { ReactComponent as LightBulbFill } from "bootstrap-icons/icons/lightbulb-fill.svg";
import { ReactComponent as FileEarmarkPlusFill } from "bootstrap-icons/icons/file-earmark-plus-fill.svg";
import { ReactComponent as FileEarmarkCheckFill } from "bootstrap-icons/icons/file-earmark-check-fill.svg";
import HelpLink from "../helpLink/HelpLink";
import "./contentEditorHeader.scss";

export const EDITOR_HEADER_ID = "contentEditorHeader";
type Props = {
  modalHeaderClass?: string;
  closeModalVariant?: CloseButtonVariant;
  modalType?: string;
  modalHeaderTitle?: string;
  locationId?: string;
};

const ContentEditorHeader: React.FC<Props> = ({
  modalHeaderClass = "",
  closeModalVariant,
  modalType,
  modalHeaderTitle,
  locationId,
}) => {
  //const action = useAppSelector(selectAction())
  //const itemId = useAppSelector(selectItemId());

  const iconTypeVariant = () => {
    switch (modalHeaderClass) {
      case "hint":
        return <LightBulbFill className="mt-1 me-3 flex-shrink-0" />;
      case "extension":
        return <FileEarmarkPlusFill className="mt-1 me-3 flex-shrink-0" />;
      case "answer":
        return <FileEarmarkCheckFill className="mt-1 me-3 flex-shrink-0" />;
      default:
        return <CardIcon activityType={modalHeaderClass || ""} />;
    }
  };

  return (
    <Modal.Header
      closeButton
      className={`modal-${modalHeaderClass} text-${closeModalVariant} ps-2`}
      closeVariant={closeModalVariant}
      id={EDITOR_HEADER_ID}
    >
      {modalHeaderClass && iconTypeVariant()}
      <span className="flex-grow-1">
        &nbsp; {/* TODO: fix modal header for translation} */}
        {/* {` ${itemId ? "Edit" : "Add"} ${modalHeaderTitle ?? modalHeaderClass} ${modalType ?? action} `} */}
      </span>
      <HelpLink
        locationId={locationId}
        className={`text-${closeModalVariant} content-editor-help text-end`}
        position={"inherit"}
      />
    </Modal.Header>
  );
};

export default ContentEditorHeader;
